import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=2376e10a&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2376e10a')) {
      api.createRecord('2376e10a', component.options)
    } else {
      api.reload('2376e10a', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=2376e10a&", function () {
      api.rerender('2376e10a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2pk6z5v8ENg7O/JS/comp/openstreetmap.vue"
export default component.exports